__turbopack_context__.v({
  "animatedTransition": "Transition-module-scss-module__-vW44G__animatedTransition",
  "fadeIn": "Transition-module-scss-module__-vW44G__fadeIn",
  "fadeOut": "Transition-module-scss-module__-vW44G__fadeOut",
  "slideIn": "Transition-module-scss-module__-vW44G__slideIn",
  "slideOut": "Transition-module-scss-module__-vW44G__slideOut",
});
